import ModalRoot from './ModalRoot';

interface UserModalProps {
  open: boolean;
  onClose: () => void;
  userId: number;
}

export default function UserModal({
  open,
  onClose,
  userId,
}: UserModalProps) {
  return (
    <ModalRoot open={open}
               onClose={onClose}
               modalName="user-modal">
      {userId}
    </ModalRoot>
  );
}
